import axiosInstance from './api'

export const fetchCounselorLorContext = async (
	studentId,
	applicationTargetId,
	{ excludeLetterId, signal } = {},
) => {
	const params = new URLSearchParams({
		applicationTargetId: String(applicationTargetId),
	})
	if (excludeLetterId) {
		params.set('excludeLetterId', String(excludeLetterId))
	}
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/context?${params.toString()}`,
		{ signal },
	)
	return data
}

export const createCounselorLorGeneration = async (
	studentId,
	payload,
	{ idempotencyKey, signal } = {},
) => {
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/generations`,
		payload,
		{
			signal,
			headers: idempotencyKey
				? { 'Idempotency-Key': idempotencyKey }
				: undefined,
		},
	)
	return data
}

export const fetchCounselorLorLetter = async (studentId, letterId, { signal } = {}) => {
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/letters/${encodeURIComponent(letterId)}`,
		{ signal },
	)
	return data
}

export const fetchCounselorLorJob = async (
	studentId,
	letterId,
	jobId,
	{ signal } = {},
) => {
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/letters/${encodeURIComponent(letterId)}/jobs/${encodeURIComponent(jobId)}`,
		{ signal },
	)
	return data
}

export const retryCounselorLorJob = async (
	studentId,
	letterId,
	jobId,
	{ signal } = {},
) => {
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/letters/${encodeURIComponent(letterId)}/jobs/${encodeURIComponent(jobId)}/retry`,
		{},
		{ signal },
	)
	return data
}

export const patchCounselorLorLetter = async (
	studentId,
	letterId,
	payload,
	{ signal } = {},
) => {
	const { data } = await axiosInstance.patch(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/letters/${encodeURIComponent(letterId)}`,
		payload,
		{ signal },
	)
	return data
}

export const downloadCounselorLorPdf = async (studentId, letterId) => {
	const res = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/letters/${encodeURIComponent(letterId)}/pdf`,
		{ responseType: 'blob' },
	)
	return res.data
}

export const listCounselorLorLetters = async (
	studentId,
	applicationTargetId = null,
	{ signal } = {},
) => {
	const query = applicationTargetId
		? `?applicationTargetId=${encodeURIComponent(applicationTargetId)}`
		: ''
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/letters${query}`,
		{ signal },
	)
	return data
}

// What the course asks of a recommender - how many letters, from whom, on what.
// Distinct from the letters this student has requested or a counselor written.
export const fetchCourseLorRequirements = async (studentId, applicationTargetId) => {
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/requirements`,
		{ params: { applicationTargetId } },
	)
	return data
}

export const refreshCourseLorRequirements = async (studentId, applicationTargetId) => {
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/requirements/refresh`,
		{ applicationTargetId },
	)
	return data
}
